import { Dropdown, LabelComponent, ErrorContainer } from 'components';
import { useFormikContext } from 'formik';
import { useAppSelector } from 'store/hooks';

const Chw = ({ disabled }: { disabled: boolean }) => {
  const formik = useFormikContext<{
    chwId: string;
  }>();
  const chws = useAppSelector((state) => state.clients.chws.data);

  return (
    <>
      <LabelComponent text="CHW" mandatory />
      <Dropdown
        label="Select"
        data={chws}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        name="chwId"
        value={formik.values.chwId}
        withGradient
        disabled={disabled}
      />
      <ErrorContainer
        visible={formik.touched.chwId && formik.errors.chwId}
        errors={formik.errors}
        name="chwId"
      />
    </>
  );
};

export default Chw;
